import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import chartsInfoReducer from './chartsInfo/chartsInfo.slice';
import portCoDataReducer from './portCoData/portCoData.slice';
import companyInfoReducer from './companyInfo/companyInfo.slice';
import loadingChartReducer from './loadingChart/loadingChart.slice';
import dashboardPDFReducer from './dashboardPDF/dashboardPDF.slice';
import chartFiltersReducer from './chartFilters/chartFilters.slice';
import chartSwitchesReducer from './chartSwitches/chartSwitches.slice';
import disabledFiltersReducer from './disabledFilters/disabledFilters.slice';
import chartFormsReducer from './chartForms/chartForms.slice';

const store = configureStore({
  reducer: {
    chartsInfo: chartsInfoReducer,
    portCoData: portCoDataReducer,
    companyInfo: companyInfoReducer,
    loadingChart: loadingChartReducer,
    dashboardPDF: dashboardPDFReducer,
    chartFilters: chartFiltersReducer,
    chartSwitches: chartSwitchesReducer,
    disabledFilters: disabledFiltersReducer,
    chartForms: chartFormsReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
